module.exports = __webpack_public_path__ + "img/navigator.ea53a436.png";